module.exports = __webpack_public_path__ + "img/anewitem-cosmetics.177d32c3.svg";